import cx from 'classnames'
import { useState } from 'react'

import { Checkbox } from '../../../shared/NarusMaterial'
import { useIGAO } from '../../context'
import {
  cancelledOrCompleted,
  capitalize,
  filterItemsByStatus,
  withDivider
} from '../../utils'
import { Issue } from '../issues'

import styles from './item.module.scss'

export function Static ({
  item,
  handleBatch,
  selectedIssueId,
  setSelectedIssueId,
  handleInputSubmit,
  prevItem
}) {
  const { filters, handleStatic } = useIGAO()
  const [ editId, setEditId ] = useState(null)
  const filteredIssues = filterItemsByStatus(item.issues, filters)
  const answerDiff = item?.diff?.answer
  const changedBothAnswer = answerDiff?.current && answerDiff?.previous
  const newValue = !changedBothAnswer
    ? answerDiff?.current || answerDiff?.previous
    : null
  const { unfavorable } = item
  const favorable = item.unfavorable === 'no' ? 'yes' : 'no'
  const filled = item.issues?.some(i => !cancelledOrCompleted(i))

  const renderCheckBoxContainer = () => {
    const bodyStyle = {
      borderRadius: '10px',
      display: 'flex'
    }
    const renderCheckBox = () => {
      const style = {
        width: '60px',
        padding: '8px',
        borderRadius: '10px'
      }
      return (
        <>
          <div
            id={item.id}
            style={{ ...style }}
            className={cx({ [styles.diff]: newValue === unfavorable })}
          >
            <Checkbox
              labelClassName={styles.igaoLabel}
              label={capitalize(unfavorable)}
              disabled={item?.issues?.some(
                i => !cancelledOrCompleted(i) && !i.draft
              )}
              value={
                item.answer === unfavorable &&
                item?.issues?.some(i => !cancelledOrCompleted(i))
              }
              onChange={() => handleStatic(item.id, 'unfavorable')}
            />
          </div>
          <div
            style={style}
            className={cx({ [styles.diff]: newValue === favorable })}
          >
            <Checkbox
              label={capitalize(favorable)}
              labelClassName={styles.igaoLabel}
              onChange={() => handleStatic(item.id, 'favorable')}
              value={item.answer === favorable}
              disabled={item.issues?.some(i => !cancelledOrCompleted(i))}
            />
          </div>
        </>
      )
    }

    if (changedBothAnswer) {
      return (
        <div
          style={bodyStyle}
          className={cx({ [styles.diff]: Object.prototype.hasOwnProperty.call(item?.diff, 'answer') })}
        >
          {renderCheckBox()}
        </div>
      )
    }
    return renderCheckBox()
  }

  return (
    <>
      {withDivider(prevItem, filters)}
      <div
        className={cx(styles.itemWrap, { [styles.filled]: filteredIssues.length > 0 })}
      >
        <div className={styles.item}>
          <div className={styles.innerBody}>
            <div className={styles.itemLabel}>
              <button
                data-cy='favorable-btn'
                className={cx({ [styles.active]: !filled })}
                onClick={() => {
                  if (!filled) {
                    handleStatic(item.id, 'favorable')
                  }
                }}
              >
                {item?.label}
              </button>
            </div>
          </div>
          {renderCheckBoxContainer()}
        </div>
      </div>
      {filteredIssues?.length > 0 && (
        <div
          className={styles.issueList}
          data-cy='issue-list'
        >
          {filteredIssues?.map(issue => (
            <Issue
              key={issue.id}
              selected={selectedIssueId === issue.id}
              setSelectedIssueId={setSelectedIssueId}
              issue={issue}
              item={item}
              editId={editId}
              setEditId={setEditId}
              handleInputSubmit={handleInputSubmit}
              handleBatch={handleBatch}
            />
          ))}
        </div>
      )}
    </>
  )
}
